module.exports = __webpack_public_path__ + "static/media/white-tick.4cfee26a.svg";